module.exports = "/images/logo.png?a56da0f3becd6fdb14f80b8ab1e84a18";